// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2b5y7","subtitle":"styles_subtitle__2XB4C"};